import {Component, Input} from "@angular/core";
import {CommonModule} from '@angular/common';
import {FieldOkItemComponent} from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './kundengruppe-kundengrp.list-view.html',
    styleUrls: ['./kundengruppe-kundengrp.list-view.scss']
})
export class KundengruppeKundengrpListView implements FieldOkItemComponent<any> {

  @Input() item: any;

  constructor() {}
}
